module.exports = {
  locales: ['pt-BR'],
  defaultLocale: 'pt-BR',
  localeDetection: false,
  pages: {
    '*': ['common'],
  },
};
